import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

export type FormatoKpi = 'numero' | 'm3' | 'porcentaje';

interface Props {
  titulo: string;
  valor: string | number;
  formato?: FormatoKpi;
  icono?: ReactNode;
  cargando?: boolean;
  /** Aplica el borde verde Adelante a la izquierda (uso puntual para destacar). */
  destacado?: boolean;
  className?: string;
}

const fmtMiles = new Intl.NumberFormat('es-CR');

function formatearValor(valor: string | number, formato: FormatoKpi): string {
  if (typeof valor === 'string') return valor;
  switch (formato) {
    case 'numero':
      return fmtMiles.format(valor);
    case 'm3':
      return `${fmtMiles.format(Number(valor.toFixed(2)))} m³`;
    case 'porcentaje':
      return `${valor.toFixed(1)}%`;
  }
}

export function KpiCard({
  titulo,
  valor,
  formato = 'numero',
  icono,
  cargando = false,
  destacado = false,
  className,
}: Props) {
  return (
    <Card className={cn(destacado && 'border-l-4 border-l-adelante-primary', className)}>
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-xs uppercase tracking-wider text-muted-foreground">
          {icono}
          {titulo}
        </CardTitle>
      </CardHeader>
      <CardContent>
        {cargando ? (
          <Skeleton className="h-9 w-32" />
        ) : (
          <p className="text-3xl font-semibold tabular-nums">{formatearValor(valor, formato)}</p>
        )}
      </CardContent>
    </Card>
  );
}
